module.exports = __webpack_public_path__ + "static/media/micronano_logo.d798be41.jpg";